module.exports = __webpack_public_path__ + "static/media/logo-techcrunch.a473e387.png";